import { render, staticRenderFns } from "./AdminMetrics.vue?vue&type=template&id=12860165&scoped=true"
import script from "./AdminMetrics.vue?vue&type=script&lang=js"
export * from "./AdminMetrics.vue?vue&type=script&lang=js"
import style0 from "./AdminMetrics.vue?vue&type=style&index=0&id=12860165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12860165",
  null
  
)

export default component.exports